import script from "./Pill.vue?vue&type=script&setup=true&lang=ts"
export * from "./Pill.vue?vue&type=script&setup=true&lang=ts"

import "./Pill.vue?vue&type=style&index=0&id=6079c5f2&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6079c5f2"]])

export default __exports__